import { Pagination } from 'platform/components';
const BORDER_TOP = {
  borderTop: '1px solid var(--color-gray-200)'
} as const;
type PaginationProps = {
  currentPage: number;
  totalPages: number;
  totalCount: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
};
export function GridPagination(props: PaginationProps) {
  if (props.totalPages <= 1) {
    return null;
  }
  return <div className="flex items-center justify-end px-3 py-2" style={BORDER_TOP}>
      <Pagination page={props.currentPage} pagesQuantity={props.totalPages} onPageChange={props.onPageChange} showPrevButton showNextButton />
    </div>;
}